import {CatalogSong, Song} from '../../../types';

export const mockSongs: Song[] = [
  {
    id: '1105939615',
    name: 'Never Be Like You (feat. Kai)',
    artistName: 'Flume',
    albumName: 'Skin',
    artwork: {
      backgroundColor: 'aa95c6',
      textColor1: '160e2c',
      textColor2: '221637',
      textColor3: '34294a',
      textColor4: '3d3054',
      smallUrl:
        'https://is1-ssl.mzstatic.com/image/thumb/Music30/v4/5c/69/c9/5c69c994-2848-eb9d-d632-3f745a893fc2/Flume_-_Skin_-_Album_Art.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is1-ssl.mzstatic.com/image/thumb/Music30/v4/5c/69/c9/5c69c994-2848-eb9d-d632-3f745a893fc2/Flume_-_Skin_-_Album_Art.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is1-ssl.mzstatic.com/image/thumb/Music30/v4/5c/69/c9/5c69c994-2848-eb9d-d632-3f745a893fc2/Flume_-_Skin_-_Album_Art.jpg/600x600bb.jpeg',
    },
    duration: 233337,
    explicit: true,
    releaseDate: '2016-01-16',
    trackNumber: 2,
  },
  {
    id: '947059827',
    name: 'Flume',
    artistName: 'Bon Iver',
    albumName: 'For Emma, Forever Ago',
    artwork: {
      backgroundColor: '020202',
      textColor1: 'ffffff',
      textColor2: 'e2deca',
      textColor3: 'cccccc',
      textColor4: 'b5b2a2',
      smallUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music5/v4/e1/7a/b1/e17ab110-b290-653d-d503-e3cea7044ef0/656605211565.tif/100x100bb.jpeg',
      mediumUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music5/v4/e1/7a/b1/e17ab110-b290-653d-d503-e3cea7044ef0/656605211565.tif/400x400bb.jpeg',
      largeUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music5/v4/e1/7a/b1/e17ab110-b290-653d-d503-e3cea7044ef0/656605211565.tif/600x600bb.jpeg',
    },
    duration: 219000,
    explicit: false,
    releaseDate: '2007-07-08',
    trackNumber: 1,
  },
  {
    id: '1105939618',
    name: 'Say It (feat. Tove Lo)',
    artistName: 'Flume',
    albumName: 'Skin',
    artwork: {
      backgroundColor: 'aa95c6',
      textColor1: '160e2c',
      textColor2: '221637',
      textColor3: '34294a',
      textColor4: '3d3054',
      smallUrl:
        'https://is1-ssl.mzstatic.com/image/thumb/Music30/v4/5c/69/c9/5c69c994-2848-eb9d-d632-3f745a893fc2/Flume_-_Skin_-_Album_Art.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is1-ssl.mzstatic.com/image/thumb/Music30/v4/5c/69/c9/5c69c994-2848-eb9d-d632-3f745a893fc2/Flume_-_Skin_-_Album_Art.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is1-ssl.mzstatic.com/image/thumb/Music30/v4/5c/69/c9/5c69c994-2848-eb9d-d632-3f745a893fc2/Flume_-_Skin_-_Album_Art.jpg/600x600bb.jpeg',
    },
    duration: 262521,
    explicit: true,
    releaseDate: '2016-04-22',
    trackNumber: 5,
  },
];

export const mockCatalogSongs: CatalogSong[] = [
  {
    id: '1440881684',
    name: 'HUMBLE.',
    trackNumber: 8,
    explicit: true,
    albumName: 'DAMN.',
    artistName: 'Kendrick Lamar',
    duration: 177000,
    releaseDate: '2017-03-30',
    artwork: {
      smallUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/600x600bb.jpeg',
      textColor1: '24191d',
      textColor2: '341e28',
      textColor3: '4c4245',
      textColor4: '59464e',
      backgroundColor: 'ebe7e8',
    },
    likes: 1,
    liked: true,
  },
  {
    id: '1440881357',
    name: 'DNA.',
    trackNumber: 2,
    explicit: true,
    albumName: 'DAMN.',
    artistName: 'Kendrick Lamar',
    duration: 185947,
    releaseDate: '2017-04-14',
    artwork: {
      smallUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/600x600bb.jpeg',
      textColor1: '24191d',
      textColor2: '341e28',
      textColor3: '4c4245',
      textColor4: '59464e',
      backgroundColor: 'ebe7e8',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440906939',
    name: 'All The Stars',
    trackNumber: 2,
    explicit: true,
    albumName: 'Black Panther The Album Music From And Inspired By',
    artistName: 'Kendrick Lamar, SZA',
    duration: 232190,
    releaseDate: '2018-01-04',
    artwork: {
      smallUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/600x600bb.jpeg',
      textColor1: 'f4f1ec',
      textColor2: 'ebebd0',
      textColor3: 'c3c1bc',
      textColor4: 'bcbca6',
      backgroundColor: '000000',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440881708',
    name: 'LOVE. (FEAT. ZACARI.)',
    trackNumber: 10,
    explicit: true,
    albumName: 'DAMN.',
    artistName: 'Kendrick Lamar',
    duration: 213400,
    releaseDate: '2017-04-14',
    artwork: {
      smallUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/600x600bb.jpeg',
      textColor1: '24191d',
      textColor2: '341e28',
      textColor3: '4c4245',
      textColor4: '59464e',
      backgroundColor: 'ebe7e8',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440829137',
    name: 'King Kunta',
    trackNumber: 3,
    explicit: true,
    albumName: 'To Pimp a Butterfly',
    artistName: 'Kendrick Lamar',
    duration: 234690,
    releaseDate: '2015-03-15',
    artwork: {
      smallUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/2c/5d/7c/2c5d7c30-8c82-a810-1f66-41131b8a989b/00602547276636.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/2c/5d/7c/2c5d7c30-8c82-a810-1f66-41131b8a989b/00602547276636.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/2c/5d/7c/2c5d7c30-8c82-a810-1f66-41131b8a989b/00602547276636.rgb.jpg/600x600bb.jpeg',
      textColor1: '060605',
      textColor2: '1e1e1d',
      textColor3: '2a2928',
      textColor4: '3d3c3b',
      backgroundColor: 'b7b5b6',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440907186',
    name: 'Pray For Me',
    trackNumber: 14,
    explicit: true,
    albumName: 'Black Panther The Album Music From And Inspired By',
    artistName: 'The Weeknd, Kendrick Lamar',
    duration: 211421,
    releaseDate: '2018-02-02',
    artwork: {
      smallUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/600x600bb.jpeg',
      textColor1: 'f4f1ec',
      textColor2: 'ebebd0',
      textColor3: 'c3c1bc',
      textColor4: 'bcbca6',
      backgroundColor: '000000',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440818969',
    name: 'Money Trees (feat. Jay Rock)',
    trackNumber: 5,
    explicit: true,
    albumName: 'good kid, m.A.A.d city (Deluxe Version)',
    artistName: 'Kendrick Lamar',
    duration: 386905,
    releaseDate: '2012-10-22',
    artwork: {
      smallUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/15/c2/d7/15c2d7eb-06f8-464d-fe40-18a2de2ca191/00602537362769.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/15/c2/d7/15c2d7eb-06f8-464d-fe40-18a2de2ca191/00602537362769.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/15/c2/d7/15c2d7eb-06f8-464d-fe40-18a2de2ca191/00602537362769.rgb.jpg/600x600bb.jpeg',
      textColor1: '100e16',
      textColor2: '162d37',
      textColor3: '3b3a40',
      textColor4: '40535b',
      backgroundColor: 'eaeaea',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440881570',
    name: 'LOYALTY. (FEAT. RIHANNA.)',
    trackNumber: 6,
    explicit: true,
    albumName: 'DAMN.',
    artistName: 'Kendrick Lamar',
    duration: 227360,
    releaseDate: '2017-04-14',
    artwork: {
      smallUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is5-ssl.mzstatic.com/image/thumb/Music118/v4/05/b1/f6/05b1f61d-944e-2699-7f08-ac195bfed8d2/00602557608717.rgb.jpg/600x600bb.jpeg',
      textColor1: '24191d',
      textColor2: '341e28',
      textColor3: '4c4245',
      textColor4: '59464e',
      backgroundColor: 'ebe7e8',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440819203',
    name: 'Swimming Pools (Drank) [Bonus Track]',
    trackNumber: 17,
    explicit: true,
    albumName: 'good kid, m.A.A.d city (Deluxe Version)',
    artistName: 'Kendrick Lamar',
    duration: 247960,
    releaseDate: '2012-07-31',
    artwork: {
      smallUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/15/c2/d7/15c2d7eb-06f8-464d-fe40-18a2de2ca191/00602537362769.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/15/c2/d7/15c2d7eb-06f8-464d-fe40-18a2de2ca191/00602537362769.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is3-ssl.mzstatic.com/image/thumb/Music118/v4/15/c2/d7/15c2d7eb-06f8-464d-fe40-18a2de2ca191/00602537362769.rgb.jpg/600x600bb.jpeg',
      textColor1: '100e16',
      textColor2: '162d37',
      textColor3: '3b3a40',
      textColor4: '40535b',
      backgroundColor: 'eaeaea',
    },
    likes: 0,
    liked: false,
  },
  {
    id: '1440907112',
    name: "King's Dead",
    trackNumber: 9,
    explicit: true,
    albumName: 'Black Panther The Album Music From And Inspired By',
    artistName: 'Jay Rock, Kendrick Lamar, Future, James Blake',
    duration: 225274,
    releaseDate: '2018-01-12',
    artwork: {
      smallUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/100x100bb.jpeg',
      mediumUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/400x400bb.jpeg',
      largeUrl:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/65/6f/04/656f044c-525a-6167-7a0b-0a9f5ec0fcf5/00602567350248.rgb.jpg/600x600bb.jpeg',
      textColor1: 'f4f1ec',
      textColor2: 'ebebd0',
      textColor3: 'c3c1bc',
      textColor4: 'bcbca6',
      backgroundColor: '000000',
    },
    likes: 0,
    liked: false,
  },
];
